import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  table: {
    overflowY: 'auto',
    marginTop: '20px',
  },
  textCell: {
    lineHeight: '40px',
    paddingLeft: '10px',
  },
  centeredCell: {
    textAlign: 'center',
  },
  zoneExistsIcon: {
    '&.MuiSvgIcon-root': {
      width: '19px',
      height: '19px',
    },
  },
  addImageZoneIcon: {
    color: '#3C419A',
  },
}));
